module.exports = __webpack_public_path__ + "static/img/apple-touch-icon-152x152.f1a4421.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple-touch-icon-152x152.png
// module id = 414
// module chunks = 1